<script type="text/ecmascript-6">
    import DesignerQuestionFrameColourInternal from "../DesignerQuestionFrameColourInternal.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionFrameColourInternal,
            SynsealTileQuestion,
        ],
        props: {
            frameMaterial: {
                required: false,
                default(){
                    return 1;
                }
            },
            slab: {
                required: true,
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/frame-colour-' + this.frameMaterial + '/';
            },
            passed_filter(){
                return this.variable_ready(this.frameColourExternal, this.slab) && (this.frameMaterial === '' || this.variable_ready(this.frameMaterial, this.slab));
            },
            url(){
                return '/api/options/' + this.fabricator + '/frame-colour-internal?frame_external_colour=' + this.frameColourExternal + '&frame_material=' + this.frameMaterial + '&slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.frameMaterial + '_' + this.frameColourExternal + '_' + this.slab;
            },
        },
        watch: {
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
        },
        mounted() {
            window.emitter.on('frame-external-colour-updated', (new_colour) => {
                if(this.fabricator === 3 && this.frameMaterial === 2){
                    this.localTarget = new_colour;
                }
            });
        },
        onUnmounted() {
            window.emitter.off('frame-external-colour-updated');
        },
    }
</script>
